import { useRegisterSubjectMutation, useRemoveRegisteredSubjectMutation } from "src/services";
import {
  HubConnection,
  HubConnectionBuilder,
  HttpTransportType,
  HubConnectionState,
} from "@microsoft/signalr";
import { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";

function useManageSlots(cb?: any) {
  const [connection, setConnection] = useState<null | HubConnection>(null);
  const [sectionsSlots, setSectionsSlots] = useState<any[]>([]);
  const [isLoadingSomething, setIsLoadingSomething] = useState(false);
  const [
    seleccionar,
    { isLoading: isLoadingSeleccion, isError: isErrorSeleccion, error: errorRem },
  ] = useRegisterSubjectMutation();
  const [
    deseleccionar,
    { isLoading: isLoadingDeseleccion, isError: isErrorDeseleccion, error: errorSel },
  ] = useRemoveRegisteredSubjectMutation();

  const getSlotsBySection = useCallback(
    (sectionId: number) => {
      const slots = sectionsSlots?.find((sec) => sec.seccionId === sectionId)?.cupoString;
      return slots ?? 0;
    },
    [sectionsSlots],
  );

  useEffect(() => {
    if ((isErrorSeleccion && errorRem?.error) || errorRem?.data) {
      if (errorRem?.data) {
        toast.error(JSON.parse(errorRem.data).message);
      } else {
        toast.error(errorRem.error);
      }
    }
  }, [isErrorSeleccion, errorRem]);

  useEffect(() => {
    if ((isErrorDeseleccion && errorSel?.error) || errorSel?.data) {
      if (errorSel?.data) {
        toast.error(JSON.parse(errorSel.data).message);
      } else {
        toast.error(errorSel.error);
      }
    }
  }, [isErrorDeseleccion, errorSel]);

  useEffect(() => {
    setIsLoadingSomething(isLoadingDeseleccion || isLoadingSeleccion);
  }, [isLoadingDeseleccion, isLoadingSeleccion, setIsLoadingSomething]);

  useEffect(() => {
    const url = process.env.REACT_APP_HUBADDRESS;
    if (!connection) {
      const connect = new HubConnectionBuilder()
        .withUrl(url ?? "", {
          skipNegotiation: true,
          transport: HttpTransportType.WebSockets,
        })
        .withAutomaticReconnect()
        .build();

      setConnection(connect);
    }
  }, [connection]);

  const disconnect = () => {
    connection?.stop().then(() => setConnection(null));
  };

  useEffect(() => {
    if (connection && connection.state === HubConnectionState.Disconnected) {
      connection
        .start()
        .then(() => {
          connection.on("receiveAvailableSlots", (res: any[]) => {
            if (cb) cb(res);

            setSectionsSlots(res);
            setIsLoadingSomething(false);
          });
        })
        .catch((error) => console.log(error));
    }
  }, [connection, cb, getSlotsBySection]);

  const getAvailableSlots = async (subjectId: number) => {
    if (connection) {
      try {
        await connection.invoke("AvailableSlots", subjectId);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const addSlot = async (seccionId: number, carreraId: number, cb?: () => void) => {
    deseleccionar({ carreraId, seccionId }).then(() => {
      if (cb) cb();
    });
  };
  const removeSlot = async (seccionId: number, carreraId: number, cb?: () => void) => {
    seleccionar({ carreraId, seccionId }).then(() => {
      if (cb) cb();
    });
  };

  return {
    addSlot,
    removeSlot,
    getAvailableSlots,
    disconnect,
    isLoadingSomething,
  };
}

export default useManageSlots;
